// CheckList.vue
<template>
    <div class="max-w-3xl mx-auto">
        <h5>Check-list avant départ</h5>

        <div class="mt-4">
            <div v-for="(item, index) in checklistItems" :key="index"
                class="mb-3 flex items-center p-4 bg-gray-50 rounded">
                <Checkbox v-model="item.checked" :binary="true" />
                <label class="ml-2">{{ item.label }}</label>
            </div>
        </div>

        <div class="mt-4 flex gap-4">
    <Button 
        label="Retour" 
        icon="pi pi-arrow-left"
        severity="secondary"
        @click="$emit('prev-step')" 
        class="w-full"
    />
    <Button 
        label="Suivant" 
        icon="pi pi-arrow-right" 
        iconPos="right"
        :disabled="!allChecksCompleted"
        @click="$emit('next-step')" 
        class="w-full"
    />
</div>
    </div>
</template>

<script setup>
import { ref, computed } from 'vue';

defineEmits(['prev-step', 'next-step']);

const checklistItems = ref([
    { label: 'Permis de conduire (en cas de contrôle de police)', checked: false },
    { label: 'Pièce d\'identité ou Passeport (pour l\'accès chez les clients)', checked: false },
    { label: 'Gilet et triangle (en cas de panne)', checked: false },
    { label: 'Niveau d\'essence suffisant pur réaliser la tournée', checked: false },
    { label: 'Diable', checked: false },
    { label: 'Cageot de fruits supplémentaires pour remplacer les fruits des clients si ils sont abimés', checked: false },
]);

const allChecksCompleted = computed(() => {
    return checklistItems.value.every(item => item.checked);
});
</script>